// CSS SELECTOR RODIČE - FORM GROUP
const PARENT_SELECTOR = '.form-group';
// CSS SELECTOR REQUIRED LABELU
const REQUIRED_SELECTOR = '.form-group-required .formRequired';
// CSS TŘÍDA REQUIRED GROUP
const REQUIRED_GROUP_CLASSNAME = 'form-group-required';
// CSS TŘÍDA REQUIRED LABEL
const REQUIRED_LABEL_CLASSNAME = 'formRequired';
// CSS TŘÍDA SCHOVANÉHO
const HIDDEN_CLASSNAME = 'd-none hidden';
//CSS ERROR
const ERROR_CLASSNAME = 'has-error has-alert';
//CSS WARNING
const WARNING_CLASSNAME = 'has-warning has-alert';

// template warning, error
// pomocné proměnné
const WARNING_MESSAGE_CLASSNAME = 'alert alert-warning alert-form-element alert-required';
const ERROR_MESSAGE_CLASSNAME = 'alert alert-danger alert-form-element alert-required';
const MESSAGE_INNER_CLASSNAME = 'alert-text';

const WARNING_MESSAGE = '<div class="'+WARNING_MESSAGE_CLASSNAME+'"><div class="alert-icon"><span class="icon-notification2" aria-hidden="true"></span></div><div class="'+MESSAGE_INNER_CLASSNAME+'">%s</div></div>';
const ERROR_MESSAGE = '<div class="'+ERROR_MESSAGE_CLASSNAME+'"><div class="alert-icon"><span class="icon-cancel-circle2" aria-hidden="true"></span></div><div class="'+MESSAGE_INNER_CLASSNAME+'">%s</div></div>';
////

const CLASSNAME2SELECTOR=v=>'.'+v.split(' ').filter(v=>v).join('.');

export class FormGroup {

    constructor (name) {
        let e;
        let element;
        if ( !(
            ( (e=name) instanceof HTMLElement)
            ||
            ( e = document.getElementsByName(name)[0] )
        )) {
            try {
                e = document.querySelector(name)
            } catch(e) {}
        }
        
        if (e instanceof HTMLElement) {
            element = e.closest(PARENT_SELECTOR);
        }
        
        Object.defineProperty(this, 'element', { writable:false, value:element||null } );
        Object.defineProperty(this, 'inputAll', { writable:false, value:[...(element?.querySelectorAll?.('input,textarea,select')??[])] } );

    }


    /* změna labelu metodou + seeterem a getterem */
    setLabel(html) {
        if (html !== undefined) this.label=html;
        return this;
    }
    get label () {
        let e;
        return this.element
            ? (( e = this.element.querySelector('label') ) ? e.innerHTML : '')
            : ''
    }
    set label (html) {
        let e;
        if (this.element && ( e = this.element.querySelector('label') )) e.innerHTML = html;
    }

    /* změna required metodou + seeterem a getterem */
    setRequired(bool) {
        this.required=bool;
        return this;
    }
    get required () {
        let e;
        return this.element
            ? (( e = this.element.querySelector('label') ) ? e.matches(REQUIRED_SELECTOR) : false)
            : false
    }
    set required (bool) {
        let e;
        if (this.element) {
            this.element.classList[bool ? 'add' : 'remove'](...REQUIRED_GROUP_CLASSNAME.split(' '));
            if ( e = this.element.querySelector('label') ) e.classList[bool ? 'add' : 'remove'](...REQUIRED_LABEL_CLASSNAME.split(' '));
        }
    }

    /* schovávání × skrývání */
    setVisible(bool) {
        this.visible=bool;
        return this;
    }
    set visible (bool) {
        if (this.element) { this.element.classList[bool ? 'remove' : 'add'](...HIDDEN_CLASSNAME.split(' ')); }
    }
    get visible () {
        return !!this.element?.offsetParent;
    }
    show() {
        this.visible=true;
        return this;
    }
    hide() {
        this.visible=false;
        return this;
    }

    set error (bool) {
        if (this.errorMessage&&!bool) this.errorMessage = '';
        if (bool) {this.warning = 0}
        if (this.element) { this.element.classList[bool ? 'add' : 'remove'](...ERROR_CLASSNAME.split(' ')); }
    }

    get error () {
        return !!(this.element?.matches?.(CLASSNAME2SELECTOR(ERROR_CLASSNAME)));
    }

    setError(bool) {
        this.error=bool;
        return this;
    }

    set warning (bool) {
        if (this.warningMessage&&!bool) this.warningMessage = '';
        if (bool) {this.error = 0}
        if (this.element) { this.element.classList[bool ? 'add' : 'remove'](...WARNING_CLASSNAME.split(' ')); }
    }

    get warning () {
        return !!(this.element?.matches?.(CLASSNAME2SELECTOR(WARNING_CLASSNAME)));
    }

    setWarning(bool) {
        this.warning=bool;
        return this;
    }

    set warningMessage (string) {
        if (string) {
            this.errorMessage = null;
        }
        if (this.element) {
            let e;
            while (e=this.element.querySelector(CLASSNAME2SELECTOR(WARNING_MESSAGE_CLASSNAME))) {e.remove();}
            if (string) {
                this.inputAll[0]?.insertAdjacentHTML?.('beforebegin', WARNING_MESSAGE.replace('%s', string))
            }
        }
        this.warning = !!string;
    }

    get warningMessage () {
        return this.element?.querySelector?.(CLASSNAME2SELECTOR(WARNING_MESSAGE_CLASSNAME)+' '+CLASSNAME2SELECTOR(MESSAGE_INNER_CLASSNAME))?.innerHTML ?? '';
    }

    setWarningMessage(string) {
        this.errorMessage=string;
        return this;
    }

    set errorMessage (string) {
        if (string) {
            this.warningMessage = null;
        }
        if (this.element) {
            let e;
            while (e=this.element.querySelector(CLASSNAME2SELECTOR(ERROR_MESSAGE_CLASSNAME))) {e.remove();}
            if (string) {
                this.inputAll[0]?.insertAdjacentHTML?.('beforebegin', ERROR_MESSAGE.replace('%s', string))
            }
        }
        this.error = !!string;
    }

    get errorMessage () {
        return this.element?.querySelector?.(CLASSNAME2SELECTOR(ERROR_MESSAGE_CLASSNAME)+' '+CLASSNAME2SELECTOR(MESSAGE_INNER_CLASSNAME))?.innerHTML ?? '';
    }

    setErrorMessage(string) {
        this.errorMessage=string;
        return this;
    }


}

window.formGroup=(...args)=>new FormGroup(...args);
